/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { useEffect, useState, useRef } from 'react';
import {
  Button,
  Row,
  Card,
  message,
  Modal,
  Input,
  Col,
  Select,
  TimePicker,
} from 'antd';
import ProTable from '@ant-design/pro-table';

import {
  getActionList,
  getActionClass,
  actionLabel,
} from '@/services/actionLibrary';

const AddAction = (props) => {
  const { open, onCancel, onOk, actionList } = props;

  // 已选择动作
  const [selectedActionRecord, setSelectedActionRecord] = useState();
  // 训练容量
  const [sequenceVal, setSequenceVal] = useState(0);
  // 训练容量 次、秒
  const [sequenceType, setSequenceType] = useState(1);
  // 动作后休息时长
  const [afterRestDuration, setAfterRestDuration] = useState(undefined);
  // 选择动作 显影
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [actionTypeEnum, setActionTypeEnum] = useState({});
  const [parts, setParts] = useState({});
  const [mode, setMode] = useState({});
  const [side, setSide] = useState({});
  const [position, setPosition] = useState({});
  const [equipment, setEquipment] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const actionRef = useRef();

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      // 已选取的动作1
      if (selectedRows.length > 0) {
        setSelectedActionRecord(selectedRows[0]);
      } else {
        setSelectedActionRecord(undefined);
      }
    },
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      // name: record.name,
    }),
  };

  const actionColumns = [
    {
      title: '动作分类',
      dataIndex: 'actionType',
      valueType: 'select',
      hideInTable: true,
      valueEnum: actionTypeEnum,
    },
    {
      title: '动作ID',
      dataIndex: 'actionId',
      copyable: true,
    },
    {
      title: '动作简称',
      dataIndex: 'shortName',
      // hideInSearch: true,
      width: 200,
    },
    {
      title: '动作分类',
      dataIndex: 'actionType',
      valueType: 'select',
      hideInSearch: true,
      valueEnum: actionTypeEnum,
    },
    {
      title: '部位',
      dataIndex: 'parts',
      valueEnum: parts,
      valueType: 'select',
      render: (_, record, index, action) => {
        return record.partsName;
      },
    },
    {
      title: '动作模式',
      dataIndex: 'mode',
      valueType: 'select',
      valueEnum: mode,
      render: (_, record, index, action) => {
        return record.modeName;
      },
    },
    {
      title: '单双侧',
      dataIndex: 'side',
      valueType: 'select',
      valueEnum: side,
      render: (_, record, index, action) => {
        return record.sideName;
      },
    },
    {
      title: '身体位置',
      dataIndex: 'position',
      valueEnum: position,
      valueType: 'select',
      render: (_, record, index, action) => {
        return record.positionName;
      },
    },
    {
      title: '设备',
      dataIndex: 'equipment',
      valueType: 'select',
      valueEnum: equipment,
      render: (_, record, index, action) => {
        return record.equipmentName;
      },
    },
  ];

  useEffect(() => {
    if (actionList) {
      setSequenceVal(actionList.sequenceVal);
      setSelectedActionRecord(actionList.selectedActionRecord);
      setSequenceType(actionList.sequenceType ? actionList.sequenceType : 1);
      setAfterRestDuration(actionList.afterRestDuration);
    }
  }, [actionList]);

  useEffect(() => {
    getActionClass({
      requestData: {
        // 查询全部
      },
    }).then(({ data, code }) => {
      if (code === '00000') {
        const obj = {};
        data.actionTypeClassModels.map((item) => {
          obj[item.actionType] = { text: item.actionName };
        });
        setActionTypeEnum(obj);
      }
    });

    actionLabel({
      requestData: {
        // 查询全部
      },
    }).then(({ data, code }) => {
      if (code === '00000') {
        const cache = data.classList;
        let parts, mode, side, position, equipment;
        cache.forEach((item) => {
          switch (item.classType) {
            case 'parts':
              parts = genValueEnum(item.optionDicts);
              break;
            case 'mode':
              mode = genValueEnum(item.optionDicts);
              break;
            case 'side':
              side = genValueEnum(item.optionDicts);
              break;
            case 'position':
              position = genValueEnum(item.optionDicts);
              break;
            case 'equipment':
              equipment = genValueEnum(item.optionDicts);
              break;
          }
        });
        setParts(parts);
        setPosition(position);
        setSide(side);
        setMode(mode);
        setEquipment(equipment);
      }
    });
  }, []);

  function genValueEnum(cache) {
    const obj = {};
    cache.forEach((item) => {
      obj[item.dictType] = { text: item.dictName };
    });
    return obj;
  }

  function onSequenceValChange(e) {
    setSequenceVal(e.target.value);
  }

  function onUnitChange(e) {
    setSequenceType(e);
  }

  function onAfterRestDurationChange(e) {
    setAfterRestDuration(e);
  }

  function pickAction() {
    setIsAddModalVisible(true);
  }

  // 点击选择动作-取消
  function addModalDisappear() {
    setIsAddModalVisible(false);
  }

  function clickCancelAction() {
    setSelectedRowKeys([]);
    onCancel();
  }

  function clickAddActionOK() {
    if (!sequenceVal || sequenceVal === '') {
      return message.error('训练容量未填');
    } else if (!afterRestDuration) {
      return message.error('休息时长未填');
    } else if (!selectedActionRecord) {
      return message.error('动作未选');
    }

    onOk({
      phaseId: actionList.phaseId,
      sequenceType: sequenceType,
      sequenceVal: sequenceVal,
      afterRestDuration: afterRestDuration,
      selectedActionRecord: selectedActionRecord,
      id: actionList.id,
    });

    setSelectedRowKeys([]);
  }

  function selectActionUI() {
    return (
      <Modal
        title="选取动作"
        width={1200}
        open={isAddModalVisible}
        onCancel={() => {
          addModalDisappear();
        }}
        onOk={() => {
          setIsAddModalVisible(false);
        }}
      >
        {addTable()}
      </Modal>
    );
  }

  const addTable = () => {
    return (
      <ProTable
        columns={actionColumns}
        actionRef={actionRef}
        request={async (params) => {
          const { data, page, code } = await getActionList({
            requestData: { ...params, status: 1, isOnlyTemplate: true },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data.actions,
            success: true,
            total: page.count,
          };
        }}
        editable={{
          type: 'multiple',
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos',
          persistenceType: 'localStorage',
        }}
        rowKey="actionId"
        search={{
          labelWidth: 'auto',
        }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        rowSelection={{
          type: 'radio',
          ...rowSelection,
        }}
        toolBarRender={() => []}
      />
    );
  };

  return (
    <Modal
      open={open}
      width={600}
      title={'添加动作'}
      cancelText={'取消'}
      okText={'确认'}
      onCancel={clickCancelAction}
      onOk={clickAddActionOK}
    >
      <Row>
        <Col>选择动作：</Col>
        <Col>
          <Button type="primary" onClick={() => pickAction()}>
            选择动作
          </Button>
        </Col>
      </Row>
      <br />
      <Card>
        {selectedActionRecord ? (
          <label style={{ color: 'blue' }}>
            {selectedActionRecord.actionId}-{selectedActionRecord.shortName}
          </label>
        ) : (
          <label style={{ color: 'lightgray' }}>还未选择</label>
        )}
      </Card>
      <br />
      <br />
      <Row>
        <Col>训练容量：</Col>
        <Col>
          <span>
            <Input
              type={'number'}
              min={1}
              value={sequenceVal}
              onChange={onSequenceValChange}
              style={{ width: 100 }}
            />
            <Select
              // value={value.currency || currency}
              defaultValue={1}
              style={{ width: 80, margin: '0 8px' }}
              value={sequenceType}
              onChange={onUnitChange}
            >
              <Select.Option value={1}>次</Select.Option>
              <Select.Option value={2}>秒</Select.Option>
            </Select>
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col>动作后休息时长：</Col>
        <Col>
          <span>
            <TimePicker
              showTime={{ format: 'mm:ss' }}
              value={afterRestDuration}
              onChange={onAfterRestDurationChange}
              showNow={false}
              secondStep={5}
              format={'mm分:ss秒'}
            />
          </span>
        </Col>
      </Row>
      {selectActionUI()}
    </Modal>
  );
};

export default AddAction;
